import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

// Resume section container with different padding
export const ResumeSectionContainer = styled(Box)({
  paddingTop: '110px',
  paddingBottom: '30px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      'linear-gradient(to bottom left, rgba(17, 16, 16, 0.582), rgba(12, 8, 24, 0.904))',
    zIndex: -1,
  },
});
// Resume content cards
export const ResumeCard = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  background: 'rgba(199, 112, 240, 0.05)',
  border: '1px solid rgba(199, 112, 240, 0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 5px 15px rgba(199, 112, 240, 0.2)',
    transform: 'translateY(-2px)',
  },
}));

// Resume specific styles
export const ResumeItem = styled(Box)({
  padding: '0 0 10px 25px',
  marginTop: '-2px',
  borderLeft: '2px solid #8a49a8',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    width: '16px',
    height: '16px',
    borderRadius: '50px',
    left: '-9px',
    top: 0,
    background: '#fff',
    border: '2px solid #8a49a8',
  },
});

export const ResumeTitle = styled(Typography)({
  lineHeight: '18px',
  fontSize: '0.9em',
  background: '#5234795d',
  padding: '8px 15px',
  display: 'inline-block',
  fontWeight: 600,
  marginBottom: '10px',
});

export const ResumeList = styled('ul')({
  paddingLeft: '20px',
  textAlign: 'justify',
  '& li': {
    paddingBottom: '10px',
    listStyle: 'none',
  },
});

// Like button styles
export const LikeItem = styled(Box)({
  paddingTop: '10px',
  fontSize: '1.1em',
});

export const LikeBtn = styled(Button)({
  backgroundColor: '#934cce5e',
  borderColor: '#934cce5e',
  padding: '0.25rem 0.98rem',
  borderRadius: '5px',
  lineHeight: '1.4',
  transition: '0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    backgroundColor: '#a24dd386',
    borderColor: '#a24dd386',
  },
});

export const AnimateLike = styled(Box)({
  animationName: 'likeAnimation',
  animationFillMode: 'forwards',
  animationDuration: '0.85s',
});

export const ForkBtn = styled(Box)({
  fontSize: '1.1em',
  paddingTop: '10px',
});

export const ForkBtnInner = styled(Box)({
  lineHeight: '1.4em',
  backgroundColor: '#934cce5e',
  padding: '0.25rem 1.1rem',
  verticalAlign: 'middle',
  textAlign: 'center',
  '&:hover': {
    transform: 'translateY(-2px)',
    backgroundColor: '#a24dd386',
    borderColor: '#a24dd386',
  },
  '&::after': {
    display: 'none',
  },
});
